<template>
  <div class="liBaiHome">
    <van-form class="container" @submit="onSubmit" validate-first>
      <van-field
        v-model="form.phone"
        type="number"
        clearable
        center
        placeholder="手机号码"
      />
      <!-- :rules="[
          { required: true, message: '请填写手机号码' },
          { pattern: /^1[3456789]\d{9}$/, message: '请填写正确的手机号码' }
        ]"
        :rules="[{ required: true, message: '请填写短信验证码' }]"
      -->
      <van-field
        v-model="form.captchaCode"
        center
        clearable
        maxlength="6"
        placeholder="短信验证码"
      >
        <template #button>
          <div v-if="!timer" @click="!yzmLoading ? getCode() : ''">
            获取验证码
          </div>
          <van-count-down v-else :time="timer" @finish="timer = 0" />
        </template>
      </van-field>
      <van-button
        block
        color="#000"
        loading-text="加载中..."
        :loading="loading"
        class="redeemBtn"
        native-type="submit"
      >
        立即领取
      </van-button>
      <div class="pickupRecord" @click="goRecordList()">我的领取记录</div>
    </van-form>
    <!-- 确认弹框 -->
    <van-dialog
      v-model="confirmVisible"
      :showConfirmButton="false"
      closeable
      :class="!confirmFirst ? ['reset-dialog', 'errorBg'] : ['reset-dialog']"
    >
      <!-- first", value = "是否第一次领取 true是 false否") -->
      <template v-if="!confirmFirst">
        <div class="txt">您已领取过 请勿重复领取</div>
        <van-button
          color="#000"
          class="confirm-btn"
          @click=";(confirmVisible = false), jumpDetail()"
        >
          查看我的领取记录
        </van-button>
      </template>
      <template v-else>
        <div class="txt">领取成功</div>
        <div class="rule">使用规则请查看券码信息</div>
        <van-button
          color="#000"
          class="confirm-btn"
          @click=";(confirmVisible = false), jumpDetail()"
        >
          确定
        </van-button>
      </template>
    </van-dialog>
    <!-- 错误弹框 -->
    <van-dialog
      v-model="errorVisible"
      :showConfirmButton="false"
      closeable
      class="reset-dialog errorBg"
    >
      <div class="txt">{{ errorMsg }}</div>
      <van-button
        color="#000"
        class="confirm-btn"
        @click="errorVisible = false"
      >
        确定
      </van-button>
    </van-dialog>
  </div>
</template>

<script>
import {
  liBaiLogin,
  liBaiSendCaptcha,
  liBaiReceive,
  liBaiReceiveOrder
} from '@/api/liBai'
export default {
  name: 'liBaiLogin',
  data() {
    return {
      form: {
        phone: '',
        captchaCode: ''
      },
      loading: false,
      yzmLoading: false,
      timer: 0,
      confirmVisible: false,
      confirmFirst: true, // 是否第一次领取 true是 false否
      errorVisible: false,
      errorMsg: undefined
    }
  },
  created() {},
  methods: {
    async getCode() {
      if (!this.form.phone) {
        this.$toast.fail('请填写手机号')
        return
      }
      try {
        this.yzmLoading = true
        await liBaiSendCaptcha({
          phone: this.form.phone
        })
        this.yzmLoading = false
        this.timer = 60000
      } catch ({ data }) {
        this.yzmLoading = false
        if (data.code === 2403) {
          // 错误弹框自定义
          this.errorMsg = data.message
          this.errorVisible = true
        } else {
          this.$toast.fail(data.message)
        }
      }
    },
    async onSubmit() {
      try {
        this.loading = true
        const { data } = await liBaiLogin(this.form)
        this.loading = false
        sessionStorage.setItem('liBaiToken', data)
        this.handleReceive()
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async handleReceive() {
      try {
        this.loading = true
        const { data } = await liBaiReceive()
        this.loading = false
        this.confirmFirst = data.first
        this.confirmVisible = true
      } catch ({ data }) {
        this.loading = false
        sessionStorage.removeItem('liBaiToken')
        if (data.code === 2403) {
          // 错误弹框自定义
          this.errorMsg = data.message
          this.errorVisible = true
        } else {
          this.$toast.fail(data.message)
        }
      }
    },
    async jumpDetail() {
      this.$router.push({
        name: 'liBaiDetail'
      })
    },
    // 登录并查询是否有领取记录
    async goRecordList() {
      if (!this.form.phone || !this.form.captchaCode) {
        this.errorMsg = '请填写手机号,验证码并点击我的领取记录！'
        this.errorVisible = true
        return
      }
      const { data: loginData } = await liBaiLogin(this.form)
      sessionStorage.setItem('liBaiToken', loginData)
      const { data } = await liBaiReceiveOrder()
      // 权益状态 0：待领取 1：已领取 2：领取失败 3：领取中
      if (data.orderStatus !== 1) {
        this.errorMsg = '暂无领取记录！'
        this.errorVisible = true
      } else {
        this.$router.push({
          name: 'liBaiDetail'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.liBaiHome {
  min-height: 100vh;
  background: #c8c0e3 url('~@/assets/img/liBai/bg.png') center center no-repeat;
  background-size: 100% auto;
  position: relative;
  .container {
    position: absolute;
    bottom: 8%;
    width: 90%;
    left: 5%;
    padding: 0px 23px 0px;
    box-sizing: border-box;
    border-radius: 15px;
    .van-cell {
      border-radius: 30px;
      margin-bottom: 20px;
      line-height: 30px;
      padding: 10px 22px;
    }
    :deep(.van-field__button) {
      color: #14A4E9;
    }
    .redeemBtn {
      color: #000;
      margin: 0px 0 20px;
      border-radius: 30px;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
    }
    .pickupRecord {
      background: url(../../assets/img/liBai/gift.png) left center no-repeat;
      background-size: 15px 15px;
      padding-left: 20px;
      font-size: 14px;
      color: #fff;
      width: 110px;
      margin: auto;
    }
  }
}
.reset-dialog {
  width: 342px;
  height: 326px;
  background: url('~@/assets/img/liBai/taskBg.png');
  background-size: 100% 100%;
  text-align: center;
  font-size: 15px;
  color: #999999;
  &.errorBg {
    background: url('~@/assets/img/liBai/taskErrorBg.png');
    background-size: 100% 100%;
    .txt {
      font-size: 24px;
      color: #3e3752;
      padding: 100px 0px 13px;
      width: 82%;
      margin: auto;
    }
  }
  :deep(.van-dialog__content) {
    margin-left: 10px;
  }
  .txt {
    font-size: 24px;
    color: #3e3752;
    padding: 144px 0px 13px;
  }
  .confirm-btn {
    width: 70%;
    margin: 40px auto 0;
    border-radius: 20px;
  }
}
</style>
